module.exports = __webpack_public_path__ + "invalid_right.svg?9e2d9b9c11c21c4d5dacd8fabe0aa586";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/invalid_right.svg
// module id = 172
// module chunks = 0